import { Card, CardActions, IconButton, Stack } from "@mui/material"
import { FormMovimentacao } from "./formMov"
import { Movimentacao, ItemMov } from "../../mov.model";
import { ClienteActions } from "../../../cliente/cliente.model";
import { FornecedorActions } from "../../../fornecedor/forn.model";
import { CardListItemMov } from "./cardsItem";
import { getNewId } from "../../../../services/utils";
import { Item, TabelaPrecoItem } from "../../../../data.types";
import ItemSelect, { ViewItemSelectModal } from "../../../item/view/item.select";
import { useCallback, useState } from "react";
import { ItemActions } from "../../../item/item.model";
import { Task } from "@mui/icons-material";
import { FuncionarioActions } from "../../../funcionario/funcionario.model";

interface TempCompraProps {
    clienteActions: ClienteActions;
    fornecedorActions: FornecedorActions;
    funcionarioActions: FuncionarioActions;
    itemActions: ItemActions;
    mutatorLocal: (value: any, field: string) => void;
    mov: Movimentacao;
    showDescontoModal: boolean;
    setShowDescontoModal: (value: boolean) => void;
}


interface CardFormularioProps extends TempCompraProps {
    setShowMovItem: (value: { item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }) => any;
}
const CardFormulario = (props: CardFormularioProps) => {
    const { clienteActions, mutatorLocal, mov, showDescontoModal, setShowDescontoModal, fornecedorActions, setShowMovItem,funcionarioActions } = props;


    const addItem = (item: Item, fast?: boolean) => {

        let newItemMov: ItemMov = {
            _id: getNewId(),
            item: {
                _id:item._id,
                codigo:item.codigo,
                descricao:item.descricao,
                tabela_preco: {} as TabelaPrecoItem  
            },
            qt: 0,
            valor: item.custo,
            total: 0,
            ano_validade: undefined,
        }
        setShowMovItem({ item: newItemMov, show: true, operation: "itemMovAdd" });
    }


    return (
        <Card sx={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-between", padding: 1 }}>
            <FormMovimentacao
                clienteActions={clienteActions}
                fornecedorActions={fornecedorActions}
                funcionarioActions={funcionarioActions}
                mutatorLocal={mutatorLocal}
                showDescontoModal={showDescontoModal}
                setShowDescontoModal={setShowDescontoModal}
                mov={mov}
                fieldShow={["codigo", "pessoa.nome", "created_at", "situacao", "fechamento.subtotal", "fechamento.desconto", "fechamento.total", "obs"]} // Exemplo de campos a serem exibidos
            />
            <ViewItemSelectModal
                handleItemSelect={(i) => addItem(i.item, false)}
                needTabPreco={false}
                //tabela={""}
            />
            <CardActions sx={{ display: "flex", justifyContent: "end" }} >
                <Stack display={"flex"} direction={"row"} spacing={1} justifyContent={"end"}>
                    <IconButton
                        title="Finalizar a movimentação"
                        onClick={() => mutatorLocal("FINALIZADO", "situacao")}
                        disabled={mov.itens.length === 0}
                    >
                        <Task />
                    </IconButton>
                </Stack>
            </CardActions>
        </Card>
    )
}

const BlockLeft = (props: CardFormularioProps) => {
    return (
        <Stack spacing={2} sx={{ display: "flex", flex: 5, flexDirection: "column", }}>
            <CardFormulario {...props} />
        </Stack>
    )
}

interface BlockRightProps extends TempCompraProps {
    setShowMovItem: (value: { item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }) => any;
    showMovItem: { item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }
}

const BlockRight = (props: BlockRightProps) => {
    const { mov, mutatorLocal, setShowMovItem, showMovItem, itemActions } = props;

    return (
        <Stack spacing={1} sx={{ display: "flex", flex: 7, flexDirection: "column", }}>
            <CardListItemMov
                mov={mov}
                mutatorLocal={mutatorLocal}
                showMovItem={showMovItem}
                setShowMovItem={setShowMovItem}
                showButtonNew={true}
                handleButtonNew={() => {
                    itemActions.setShowSelectModal(true)
                    itemActions.read()
                }}

            />
        </Stack>
    )
}

export const TemplateCompra = (props: TempCompraProps) => {
    const [showMovItem, setShowMovItem] = useState<{ item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }>({ item: {} as ItemMov, show: false, operation: "" })
    return (
        <Stack sx={{ display: "flex", flex: 1, flexDirection: "row" }}>
            <BlockLeft
                clienteActions={props.clienteActions}
                fornecedorActions={props.fornecedorActions}
                funcionarioActions={props.funcionarioActions}
                mutatorLocal={props.mutatorLocal}
                mov={props.mov}
                showDescontoModal={props.showDescontoModal}
                setShowDescontoModal={props.setShowDescontoModal}
                setShowMovItem={setShowMovItem}
                itemActions={props.itemActions}
            />
            <BlockRight
                clienteActions={props.clienteActions}
                fornecedorActions={props.fornecedorActions}
                funcionarioActions={props.funcionarioActions}
                mutatorLocal={props.mutatorLocal}
                mov={props.mov}
                showDescontoModal={props.showDescontoModal}
                setShowDescontoModal={props.setShowDescontoModal}
                setShowMovItem={setShowMovItem}
                showMovItem={showMovItem}
                itemActions={props.itemActions}
            />
        </Stack>
    )
}